'use strict'
let watermark = {}
let setWatermark = (str,left) => {
  let id = '1.23452384164.123412415'
  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }
 //创建画布
  let can = document.createElement('canvas')
  can.width = 300 //画布的宽
  can.height = 150 //画布的高
 //获取画笔上下文对象
  let cans = can.getContext('2d') 
  cans.rotate(-30 * Math.PI / 180) //旋转画笔
  cans.font = '14px Helvetica ' // 设置文本大小和字体
  cans.fillStyle = 'rgba(200, 200, 200, 0.1)' //字体样式 填充颜色
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(str, 0, 160) //绘制填充文本(str,x,y) 填充字体的 坐标
	//创建div
  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px' //距离顶部的位置
  div.style.left = left
  div.style.position = 'fixed'//定位
  div.style.zIndex = '10000' //层级关系
  div.style.width = document.documentElement.clientWidth + 'px' //div的宽高
  div.style.height = document.documentElement.clientHeight  + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat' //平铺重复  no-repeat不重复
  document.body.appendChild(div)
  return id
} 
// 该方法只允许调用一次
watermark.set = (str,left) => {
  let id = setWatermark(str,left)
 
    if (document.getElementById(id) === null) {
      id = setWatermark(str,left)
    }

  window.onresize = () => {
    setWatermark(str,left)
  }
  return id
}
export default watermark